import { render } from "./SelectCenter.vue?vue&type=template&id=78effb52&scoped=true"
import script from "./SelectCenter.vue?vue&type=script&lang=js"
export * from "./SelectCenter.vue?vue&type=script&lang=js"

import "./SelectCenter.vue?vue&type=style&index=0&id=78effb52&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78effb52"]])

export default __exports__